export var DocsBlockItemPropertyTextStyle;
(function (DocsBlockItemPropertyTextStyle) {
    /** Small text */
    DocsBlockItemPropertyTextStyle["small"] = "Small";
    /** Regular text */
    DocsBlockItemPropertyTextStyle["regular"] = "Regular";
    /** Bold text */
    DocsBlockItemPropertyTextStyle["bold"] = "Bold";
})(DocsBlockItemPropertyTextStyle || (DocsBlockItemPropertyTextStyle = {}));
